/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSurveyResponseAsync$Plain$Params {

/**
 * surveyresponse id
 */
  surveyResponseId: number;
}

export function deleteSurveyResponseAsync$Plain(http: HttpClient, rootUrl: string, params: DeleteSurveyResponseAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyResponseAsync$Plain.PATH, 'delete');
  if (params) {
    rb.path('surveyResponseId', params.surveyResponseId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

deleteSurveyResponseAsync$Plain.PATH = '/api/SurveyResponse/{surveyResponseId}';
